import React, { useEffect, useState } from "react";

// @mui material components
import Api from "../../Classes/API/UsersApi";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { useNavigate } from "react-router-dom";
import Link from "@mui/material/Link";
import { useLocation, NavLink } from "react-router-dom";
import MDTypography from "components/MDTypography";
import SettingsIcon from "@mui/icons-material/Settings";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Pagination from "@mui/material/Pagination";

// Material Dashboard 2 React example components
import Swal from "sweetalert2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SearchTherapistTypes from "../../Classes/Models/Requests/Administration/Therapists/SearchTherapistTypes";
import DeleteTherapistTypes from "../../Classes/Models/Requests/Administration/Therapists/DeleteTherapistTypes";
import TextField from "@mui/material/TextField";
import { useContext } from "react";
import Button from "@mui/material/Button";
import MDInput from "components/MDInput";
import CardHeader from "@mui/material/CardHeader";
import { Icon } from "@mui/material";
import MDButton from "components/MDButton";
import { LanguageContext } from "App";
import "./therapiststylestylee.scss";
import Loader from "Loader";
const TherapistTypeList = () => {
  let searchModel = new SearchTherapistTypes();
  let deleteModel = new DeleteTherapistTypes();
  const { translations } = useContext(LanguageContext);
  const [TherapistTypes, SetTherapistTypes] = useState([]);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);
  const [IsLoaded, setIsLoaded] = useState(false);

  useEffect(async () => {
    setIsLoaded(false);
    let searchModel = new SearchTherapistTypes();
    // searchModel.id = document.getElementById('id').value;
    searchModel.typeName = document.getElementById("name").value;
    searchModel.standardHourlyRate = document.getElementById("horlyrate").value;
    searchModel.PagingParams.pageNumber = Page;

    Api.SearchTherapistTypes(searchModel).then((result) => {
      console.log(result);
      SetTherapistTypes(result.data.list);
      setPaginationPages(result.data.totalPages);
    });
    setIsLoaded(true);
  }, [Page]);

  const navigate = useNavigate();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }

  useEffect(() => {
    fetchTherapistTypes(searchModel);
  }, ["default"]);

  async function fetchTherapistTypes(searchModel) {
    setIsLoaded(false);

    Api.SearchTherapistTypes(searchModel).then((result) => {
      console.log(result);
      SetTherapistTypes(result.data.list);
      setPaginationPages(result.data.totalPages);
      setIsLoaded(true);
    });
  }

  async function onSearch() {
    setIsLoaded(false);
    let searchModel = new SearchTherapistTypes();
    // searchModel.id = document.getElementById('id').value;
    searchModel.typeName = document.getElementById("name").value;
    searchModel.standardHourlyRate = document.getElementById("horlyrate").value;

    Api.SearchTherapistTypes(searchModel).then((result) => {
      console.log(result);
      SetTherapistTypes(result.data.list);
      setPaginationPages(result.data.totalPages);
      setIsLoaded(true);
    });
  }

  async function deleteTherapistType(id) {
    deleteModel.searchInt = id;
    await Swal.fire({
      title: "Confirm delete ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Api.DeleteTherapistTypes(deleteModel).then((result) => {
          console.log(result);
          result.status == "Success"
            ? Swal.fire("Deleted!", "", "success")
            : Swal.fire("Not deleted , Unknown error Occured!");
          fetchTherapistTypes(searchModel);
        });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  }

  return (
    <div>
      <DashboardLayout>
        {/* Page Title */}
        <DashboardNavbar />

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader className="mb-2" title={translations.EmployeeTypeTitle}></CardHeader>

            <div className="container-fluid">
              <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
                <div className="row">
                  <div className="col-md-6">
                    {/* <MDInput className="full-width" id="name" label={translations.EmployeeTypeTherapisttypename} fullWidth/> */}
                  </div>

                  <div className="col-md-6">
                    <TextField
                      className="full-width"
                      id="horlyrate"
                      label={translations.EmployeeTypeTherapistTypeHourlyRate}
                      type="number"
                      fullWidth
                    />
                  </div>
                </div>

                <div className="text-right mt-3 ">
                  <Button
                    className="white"
                    sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                    size="medium"
                    onClick={onSearch}
                  >
                    {translations.sessionPgSessionsSearch}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!IsLoaded && <Loader />}
        {IsLoaded && (
          <div className="card mt-5">
            {/* <MDBox
              mx={2}
              mt={-5}
              py={3}
              px={2}
              sx={{ backgroundColor: "#3560AD" }}
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <div className="therapy-type-btn">
                <MDTypography variant="h6" color="white" mt={1}>
                  <span>{translations.TherapistTypetablez} </span>
                </MDTypography>
                <Button
                  className="white float-right"
                  color="primary"
                  sx={{ backgroundColor: "#4682B4", "&:hover": { backgroundColor: "#B0DFE5" } }}
                  size="medium"
                  component={NavLink}
                  to="/createTherapistType"
                >
                  {translations.TherapistTypetable}
                </Button>
              </div>
            </MDBox> */}

            <div className="card-body">
              <div className="container-fluid">
                <div className="row">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">{translations.sessionWithoutEnteriesid}</th>
                        <th scope="col">{translations.EmployeeTypetableStandardHourlyRate}</th>
                        <th scope="col">{translations.EmployeeTypetableTypename}</th>
                        <th scope="col">{translations.EmployeeTypetableedit}</th>
                        <th scope="col">{translations.EmployeeTypetabledelete}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {TherapistTypes.map((Therapist) => {
                        return (
                          <tr key={Therapist.id}>
                            <th scope="row">{Therapist.id}</th>
                            <th scope="row">{Therapist.standardHourlyRate}</th>
                            <th scope="row">{Therapist.typeName}</th>
                            <th scope="row">
                              <MDTypography
                                onClick={handleOnClick.bind(
                                  this,
                                  "/editTherapistType/" + Therapist.id
                                )}
                                component="a"
                                variant="button"
                                color="text"
                                fontWeight="medium"
                              >
                                <Icon>settings</Icon>
                              </MDTypography>
                            </th>
                            <th scope="row">
                              <MDButton
                                onClick={deleteTherapistType.bind(this, Therapist.id)}
                                sx={{ backgroundColor: "#333333" }}
                                color="dark"
                              >
                                <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                              </MDButton>
                            </th>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="text-right mx-3 my-4">
                  <Pagination
                    count={PaginationPages}
                    color="primary"
                    onChange={(e, number) => setPage(number)}
                    className="float-right"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </DashboardLayout>
    </div>
  );
};

export default TherapistTypeList;
